import { FC, PropsWithChildren } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { History } from './History';
import { InsuranceStatus } from './InsuranceStatus';
import { PatientDetails } from './PatientDetails';
import { PayerDetails } from './PayerDetails';
import { PlanDetails } from './PlanDetails';
import { Provisions } from './Provisions';
import { insuranceDetailsSectionStyles } from './styles';
import { SubscriberDetails } from './SubcriberDetails';

interface InsuranceReportHeaderDetailsProps {
  styles?: Interpolation<Theme>;
}

interface InsuranceReportHeaderDetailsNamespace extends FC<PropsWithChildren<InsuranceReportHeaderDetailsProps>> {
  InsuranceStatus: typeof InsuranceStatus;
  PayerDetails: typeof PayerDetails;
  PlanDetails: typeof PlanDetails;
  PatientDetails: typeof PatientDetails;
  SubscriberDetails: typeof SubscriberDetails;
  Provisions: typeof Provisions;
  History: typeof History;
}

export const InsuranceReportHeaderDetails: InsuranceReportHeaderDetailsNamespace = ({ children }) => {
  return <section css={insuranceDetailsSectionStyles}>{children}</section>;
};

InsuranceReportHeaderDetails.InsuranceStatus = InsuranceStatus;
InsuranceReportHeaderDetails.PayerDetails = PayerDetails;
InsuranceReportHeaderDetails.PlanDetails = PlanDetails;
InsuranceReportHeaderDetails.PatientDetails = PatientDetails;
InsuranceReportHeaderDetails.SubscriberDetails = SubscriberDetails;
InsuranceReportHeaderDetails.Provisions = Provisions;
InsuranceReportHeaderDetails.History = History;
